import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const ETTSizeUI = (props: UIProperties<ETTSizeUIConfig>) => {
	const [sizePicked, setSizePicked] = useState("");
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '890px',
				height: '390px'
			}}>
				<div style={{
					width: '100%',
					height: '390px',
					position: 'absolute',
					top: '0',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					<div style={{
						position: 'absolute',
						top: '31px',
						left: '3px',
						width: '100%',
						height: '65px',
					}}>
						<p style={{
							margin: '0px',
							fontSize: '20pt',
							textAlign: 'center',
							position: 'relative',
							top: '13px'
						}} className="title-font" tabIndex={0} id='ett-size-top'>Select which ETT size you would like.</p>
					</div>

					<CustomETTSizeButton 
						showYellowThingyOnTheSide={sizePicked === '5'}
						width= '180px'
						text='5'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '147px',
							left: '41px'
						}}
						onClicked={() => {
							setSizePicked('5');
						}}/>
					<CustomETTSizeButton 
						showYellowThingyOnTheSide={sizePicked === '6'}
						width= '180px'
						text='6'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '147px',
							left: '251px'
						}}
						onClicked={() => {
							setSizePicked('6');
						}}/>
					<CustomETTSizeButton 
						showYellowThingyOnTheSide={sizePicked === '7'}
						width= '180px'
						text='7'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '147px',
							left: '461px'
						}}
						onClicked={() => {
							setSizePicked('7');
						}}/>

					<CustomETTSizeButton 
						showYellowThingyOnTheSide={sizePicked === '8'}
						width= '180px'
						text='8'
						id= {sizePicked === '' ? 'ett-size-bottom' : null}
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '147px',
							left: '671px'
						}}
						onClicked={() => {
							setSizePicked('8');
						}}/>
					
					<GeneralButtonWithText parameters= {{
						text: 'Next',
						ariaLbl: 'next',
						id: sizePicked === '' ? null : 'ett-size-bottom',
						top: '354px',
						left: '370px',
						width: '140px',
						isDisabled: sizePicked === '',
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
						},
						customButtonStyle : {
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							props.parameters.onNextClicked(sizePicked);
						}
					}}/>
					
				</div>
				
			</div>
		</div>
	);

};

const CustomETTSizeButton = (props: CustomETTSizeButtonConfig) => {
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: props.width,
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					ariaLbl: props.text,
					text: '',
					top: '0px',
					left: '0px',
					id: props.id,
					isDisabled: props.isDisabled,
					width: props.width,
					srcIdle: './assets/images/general/buttons/button_side_large-1.png',
					srcHighlight: null,
					srcDisabled: './assets/images/general/buttons/button_side_large-1.png',
					customMainStyle: {
						position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>

				<div style={{
					position: 'absolute',
					top: '23px',
					pointerEvents: 'none',
					left: '46%',
					transform: 'translate(-50%, 0)',
					width: '60px'
				}}>
					<img style={{
						position: 'relative',
						top: '0',
						left: '50%',
						transform: 'translate(-50%, 0)',
						width: 'calc(' + props.width+'/2)'
					}} src="./assets/images/Toolbag/icon_ett.png" />
				</div>
				
				<div style={{
					position: 'absolute',
					pointerEvents: 'none',
					width: '166px',
					left: '0px',
					bottom: '20px'
				}}>
					<div style={{
						position: 'relative',
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '16pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>

				{props.showYellowThingyOnTheSide ? (
					<img style={{
						position: 'absolute',
						top: 0,
						right: '-23px',
						width: '36px',
						pointerEvents: 'none'
					}} src="./assets/images/general/buttons/button_side_pointer.png" />
				) : (null)}
			</div>
		</div>
	);
};

interface CustomETTSizeButtonConfig {
	text: string;
	width: string;
	id?: string;
	position: CustomETTSizeButtonPosition;
	showYellowThingyOnTheSide?: boolean;
	isDisabled?: boolean;
	onClicked?: () => void;
}

interface CustomETTSizeButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface ETTSizeUIConfig extends BaseConfig{
	onNextClicked: (sizePicked: string) => void;
}

export default ETTSizeUI;